var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 3.10457C11.25 2.52316 10.7538 2.0598 10.182 2.16484C5.52714 3.01978 2 7.09798 2 12C2 17.5229 6.47715 22 12 22C16.902 22 20.9802 18.4729 21.8351 13.818C21.9402 13.2462 21.4768 12.75 20.8954 12.75H17.545C17.0532 12.75 16.6452 13.1128 16.482 13.5768C15.8318 15.4251 14.0706 16.75 12 16.75C9.37665 16.75 7.25 14.6234 7.25 12C7.25 9.92935 8.57492 8.16816 10.4232 7.51795C10.8872 7.35474 11.25 6.94678 11.25 6.45497V3.10457Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8351 10.1819C21.9402 10.7538 21.4768 11.25 20.8954 11.25H17.545C17.0532 11.25 16.6452 10.8871 16.482 10.4232C16.0054 9.06825 14.9317 7.99462 13.5768 7.51796C13.1129 7.35475 12.75 6.94677 12.75 6.45496V3.10456C12.75 2.52315 13.2462 2.0598 13.8181 2.16483C17.8833 2.91151 21.0885 6.11664 21.8351 10.1819Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 12C8.75 10.2051 10.2051 8.75 12 8.75C13.7949 8.75 15.25 10.2051 15.25 12C15.25 13.7949 13.7949 15.25 12 15.25C10.2051 15.25 8.75 13.7949 8.75 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.5561f25b89d66859e8bdd2d362ba0d17.svg";
export { ForwardRef as ReactComponent };